export const listenOpts: {
  hasPassive: boolean
  passiveCapture: boolean
  notPassiveCapture: boolean
  passive: {
    hasPassive: true
    passive: { passive: true }
    notPassive: { passive: false }
    passiveCapture: { passive: true; capture: true }
    notPassiveCapture: { passive: false; capture: true }
  }
} = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
} as any

try {
  const opts = Object.defineProperty({}, 'passive', {
    get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      })
    }
  })
  window.addEventListener('atest', null, opts)
  window.removeEventListener('atest', null, opts)
} catch (e) {}

export function noop() {}

export function leftClick(e: MouseEvent) {
  return e.button === 0
}

export function middleClick(e: MouseEvent) {
  return e.button === 1
}

export function rightClick(e: MouseEvent) {
  return e.button === 2
}

export function position(e: TouchEvent | Event) {
  if ('touches' in e && e.touches[0]) {
    e = e.touches[0]
  } else if ('changedTouches' in e && e.changedTouches[0]) {
    e = e.changedTouches[0]
  } else if ('targetTouches' in e && e.targetTouches[0]) {
    e = e.targetTouches[0]
  }

  return {
    top: e.clientY,
    left: e.clientX
  }
}

export function getEventPath(e) {
  if (e.path) {
    return e.path
  }
  if (e.composedPath) {
    return e.composedPath()
  }

  const path = []
  let el = e.target

  while (el) {
    path.push(el)

    if (el.tagName === 'HTML') {
      path.push(document)
      path.push(window)
      return path
    }

    el = el.parentElement
  }
}

// Reasonable defaults
const LINE_HEIGHT = 40,
  PAGE_HEIGHT = 800

export function getMouseWheelDistance(e) {
  let x = e.deltaX,
    y = e.deltaY

  if ((x || y) && e.deltaMode) {
    const multiplier = e.deltaMode === 1 ? LINE_HEIGHT : PAGE_HEIGHT
    x *= multiplier
    y *= multiplier
  }

  if (e.shiftKey && !x) {
    ;[y, x] = [x, y]
  }

  return { x, y }
}

export function stop(e: Event) {
  e.stopPropagation()
}

export function prevent(e: Event) {
  e.cancelable !== false && e.preventDefault()
}

export function stopAndPrevent(e: Event) {
  e.cancelable !== false && e.preventDefault()
  e.stopPropagation()
}

export function preventDraggable(el: HTMLElement, status: boolean) {
  if (el === undefined || (status === true && el.__dragPrevented === true)) {
    return
  }

  const fn =
    status === true
      ? (el) => {
          el.__dragPrevented = true
          el.addEventListener(
            'dragstart',
            prevent,
            listenOpts.notPassiveCapture
          )
        }
      : (el) => {
          delete el.__dragPrevented
          el.removeEventListener(
            'dragstart',
            prevent,
            listenOpts.notPassiveCapture
          )
        }

  el.querySelectorAll('a, img').forEach(fn)
}

export function addEvt(
  ctx: Record<string, unknown[]>,
  targetName: string,
  events: [HTMLElement, string, string, string][]
) {
  const name = `__a_${targetName}_evt`

  ctx[name] = ctx[name] !== undefined ? ctx[name].concat(events) : events

  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]])
  })
}

export function cleanEvt(ctx, targetName: string) {
  const name = `__a_${targetName}_evt`

  if (ctx[name] !== undefined) {
    ctx[name].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]])
    })
    ctx[name] = undefined
  }
}

/*
 * also update /types/utils/event.d.ts
 */

export default {
  listenOpts,
  leftClick,
  middleClick,
  rightClick,
  position,
  getEventPath,
  getMouseWheelDistance,
  stop,
  prevent,
  stopAndPrevent,
  preventDraggable
}
